import type { Validator } from './types';

export interface FormValuesWithSocialLinks {
    instagramUrl?: string;
    telegramUrl?: string;
    vkUrl?: string;
    [key: string]: any;
}

export function makeSocialLinksValidator(
    message: string = 'Необходимо заполнить хотя бы одну социальную сеть',
): Validator<any> {
    return (_: any, allValues?: FormValuesWithSocialLinks) => {
        if (!allValues) {
            return message;
        }

        const { instagramUrl, telegramUrl, vkUrl } = allValues;

        // Проверяем, что хотя бы одно поле заполнено и не пустое
        const hasAtLeastOneField = Boolean(
            (instagramUrl && instagramUrl.trim()) ||
                (telegramUrl && telegramUrl.trim()) ||
                (vkUrl && vkUrl.trim()),
        );

        return hasAtLeastOneField ? undefined : message;
    };
}
